module.exports = "https://cdn01.riselinkedu.com/assets/images/professor.17ce352.png";